<template>
    <v-dialog v-model="dialog" persistent no-click-animation max-width="500">
        <v-card>
            <v-card-title>
                <h3 class="title">
                    {{ $t('routines.replace_routines') }}
                </h3>
                <v-spacer></v-spacer>
                <v-icon @click="hide">mdi-close-circle-outline</v-icon>
            </v-card-title>
            <v-card-text>
                {{ $t('routines.student_already_have_routine') }}
                <br>
                {{ $t('routines.select_student_to_replace_routine') }}

                <v-checkbox
                    v-for="(routine,i) in toReplace"
                    :key="routine.assignedRoutineId"
                    v-model="routine.replace"
                    :label="routine.studentName"
                    color="accent"
                ></v-checkbox>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small depressed @click.stop="onCancel">
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-btn small depressed @click.stop="onConfirm" class="black--text" color="primary">
                    {{ $t('common.confirm') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
export default{
    name: "SelectReplaceAssignedRoutinesDialog",
    props: {
        assignedRoutinesInSameDate: {
            type: Array,
            default: () => [],
        },
    },
    data(){
        return {
            dialog: false,
            date: '',
            toReplace: [],
        }
    },
    computed:{
        ...mapState(['dialogActive']),
    },
    methods:{
        ...mapMutations(['setDialogActive']),
        show(date){
            const vm = this
            vm.date = date
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide(){
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
        onConfirm(){
            this.$emit('confirm', {
                date: this.date,
                toReplace: this.toReplace,
            })
            this.hide()
        },
        onCancel(){
            this.$emit('cancel')
            this.hide()
        },
    },
    watch:{
        dialogActive(val){
            if(!val){
                this.hide()
            }
        },
        assignedRoutinesInSameDate(val) {
            this.toReplace = val
        },
    }
}
</script>

<style scoped>

</style>